import { object, string } from 'yup'

import type { CreateObjectPriceStepResponse } from 'shared/api/kyrgyzstan/create-object'
import { createYupFormResolver } from 'shared/lib/form'

export interface CreateObjectPriceFormValues {
  nightlyPrice: string
}

export const createObjectPriceFormDefaultValues: CreateObjectPriceFormValues = {
  nightlyPrice: '',
}

const requiredFieldMessage = ''
const integerPriceRegExp = /^\d+$/

const isValidNightlyPrice = (value?: string) => {
  if (!value) {
    return false
  }

  return integerPriceRegExp.test(value) && Number(value) >= 1
}

const createObjectPriceFormSchema = object({
  nightlyPrice: string()
    .trim()
    .required(requiredFieldMessage)
    .test('valid-nightly-price', requiredFieldMessage, isValidNightlyPrice),
})

export const createObjectPriceFormResolver =
  createYupFormResolver<CreateObjectPriceFormValues>(
    createObjectPriceFormSchema,
  )

export const mapCreateObjectPriceResponseToFormValues = ({
  base_price: basePrice,
}: CreateObjectPriceStepResponse): CreateObjectPriceFormValues => {
  const price = Number(basePrice)

  return {
    nightlyPrice:
      basePrice && Number.isInteger(price) ? String(price) : basePrice,
  }
}
